module.exports = __webpack_public_path__ + "static/media/arrow1.5bfae806.jpg";